import * as React from 'react';
import { connect } from 'react-redux';
import { EditorState, convertFromRaw } from 'draft-js';

import classnames from 'classnames';
import Modal, {
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
} from '../../../../common/modal'; //TODO: Keep this in components
import { Project, QTYPES, QuestionSummary } from '@nexxt/common/types';
import CheckboxMultiSelectPipeOption from '../../../../common/reactSelect/CheckboxMultiSelectPipeOption';
import { IApplicationState } from '../../../../../reducers';
import { getFilteredOption } from '../../../../../utils/string';
import { flattenQuestionSummary } from '../../../../../utils/question';
import { PIPING_OPTION_QTYPES } from '../../../../../constants/question';

interface PipeOptionModalProps {
    questionSummaries: QuestionSummary[];
    currentProject: Project;
    setSelectedPipeOption: (keyname, response) => void;
    languages: any[];
    value: any;
    showRandomize: boolean;
    onClose: () => void;
    isOpen: boolean;
    currentQuestionId: number;
}

class PipeOptionModal extends React.Component<PipeOptionModalProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 'question-type',
            selectedQuestionType: ''
        };
    }

    renderPipeOptionModal = (options) => {
        const newPipeOptions = getFilteredOption(
            this.props.value,
            flattenQuestionSummary(this.props.questionSummaries)
        );

        return (
            <form className="form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-group option-height">
                    <label className="form-group__label form-group__label--block">
                        Use the respondent&apos;s answer from this question as
                        options
                    </label>
                    <CheckboxMultiSelectPipeOption
                        options={options}
                        value={newPipeOptions}
                        onChangeCallback={this.props.setSelectedPipeOption}
                    />
                </div>
            </form>
        );
    };

    render() {
        const { props } = this;
        const flattenedQuestionSummaries = flattenQuestionSummary(
            props.questionSummaries || []
        );

        const popupQTypes = [QTYPES.POPUP_CARD, QTYPES.MULTI_POPUP_CARD];
        const selectedQuestions = flattenedQuestionSummaries.filter((qt) =>
            props.value?.map((v) => v?.id)?.includes(qt.id)
        );
        // TO prevent from piping multiple popup cards which are under same POPUP
        const disabledPopupIds = selectedQuestions
            .filter((q) => popupQTypes.includes(q.type as QTYPES))
            .map((q) => q.parent);

        const options = flattenedQuestionSummaries
            .filter(
                (question) =>
                    question.id != this.props.currentQuestionId &&
                    !question.isAudience &&
                    PIPING_OPTION_QTYPES.includes(question.type as QTYPES)
            )
            .map((question) => {
                const questionTextsObject = {};
                question &&
                    (question.questionTexts || []).forEach((texts) => {
                        questionTextsObject[texts.language] = texts;
                    });
                let greetingText: any = null;
                try {
                    this.props.languages.forEach((l) => {
                        if (!greetingText) {
                            greetingText =
                                (questionTextsObject[l.value] &&
                                    questionTextsObject[l.value].text) ||
                                null;
                        }
                    });
                } catch (e) {
                    greetingText = null;
                }
                if (greetingText) {
                    const editorState = EditorState.createWithContent(
                        convertFromRaw(greetingText)
                    );
                    greetingText =
                        editorState.getCurrentContent().getPlainText() || '';
                }
                const isDisabled =
                    disabledPopupIds.includes(question?.parent) &&
                    !selectedQuestions.find((q) => q.id === question.id);
                const newQuestion = {
                    ...question,
                    greetingText: greetingText || '',
                    randomizeOption: this.props.showRandomize || false,
                    reversePiping: question['reversePiping'] || false,
                    isDisabled
                };
                delete newQuestion['options'];
                return { ...newQuestion };
            });

        return (
            <Modal
                isOpen={props.isOpen}
                className={classnames('modal-dialog--pipe-options')}
            >
                <ModalHeader onClose={props.onClose}>
                    <ModalTitle>Pipe options from</ModalTitle>
                </ModalHeader>
                <ModalBody>{this.renderPipeOptionModal(options)}</ModalBody>
                <ModalFooter>
                    <button
                        onClick={props.onClose}
                        className="btn btn--sm btn--transparent m-r-10"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={props.onClose}
                        className="btn btn--sm btn--green"
                    >
                        Done
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        questionReducer: { questionSummaries, currentQuestionId },
        projectReducer: { currentProject }
    } = store;
    return {
        questionSummaries: questionSummaries[currentProject.id],
        currentProject,
        currentQuestionId,
        languages: currentProject.languages
    };
};

export default connect(mapStateToProps, null)(PipeOptionModal);
